import axios from 'axios';
import { apiHealthService } from './apiHealthService';
import {
  FormEditorDto,
  FormFieldEditorDto,
  CreateFormFieldEditorDto,
  UpdateFormFieldEditorDto,
  GenerateSqlResponse,
  SectionPdfConfig
} from '../types/formEditor';

const API_BASE_URL = process.env.REACT_APP_API_URL || `${apiHealthService.getApiUrl()}/api`;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add auth token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const formEditorService = {
  // Get all forms
  async getForms(): Promise<FormEditorDto[]> {
    const response = await axiosInstance.get<FormEditorDto[]>('/formeditor/forms');
    return response.data;
  },

  // Get a single form with all fields
  async getForm(formId: number): Promise<FormEditorDto> {
    const response = await axiosInstance.get<FormEditorDto>(`/formeditor/forms/${formId}`);
    return response.data;
  },

  // Create a new field
  async createField(dto: CreateFormFieldEditorDto): Promise<FormFieldEditorDto> {
    const response = await axiosInstance.post<FormFieldEditorDto>('/formeditor/fields', dto);
    return response.data;
  },

  // Update a field
  async updateField(id: number, dto: UpdateFormFieldEditorDto): Promise<FormFieldEditorDto> {
    const response = await axiosInstance.put<FormFieldEditorDto>(`/formeditor/fields/${id}`, dto);
    return response.data;
  },

  // Delete a field
  async deleteField(id: number): Promise<void> {
    await axiosInstance.delete(`/formeditor/fields/${id}`);
  },

  // Generate SQL script for a form
  async generateSql(formId: number): Promise<string> {
    const response = await axiosInstance.get<GenerateSqlResponse>(`/formeditor/forms/${formId}/sql`);
    return response.data.sql;
  },

  // Generate UPDATE SQL script for a form
  async generateUpdateSql(formId: number): Promise<string> {
    const response = await axiosInstance.get<GenerateSqlResponse>(`/formeditor/forms/${formId}/sql/update`);
    return response.data.sql;
  },

  // Update a section
  async updateSection(id: number, dto: any): Promise<any> {
    const response = await axiosInstance.put(`/formeditor/sections/${id}`, dto);
    return response.data;
  }
};
